// extracted by mini-css-extract-plugin
module.exports = {"container":"Subscribe_container__2z_d3","title":"Subscribe_title__flJnh","list":"Subscribe_list__2Dqa_"};